import {Component, Input, OnInit} from '@angular/core';
import {UserRoleCategoryModel} from '../../../../shared/dto/user-role-category.model';
import {Status} from '../../../../shared/enums/status.enum';
import {Router} from '@angular/router';
import {UserroleCategoryService} from '../../../../shared/service/userrole-category.service';
import {UserRolesCategoryComponent} from '../user-roles-category.component';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserRoleCategoryPopupComponent} from '../user-role-category-popup/user-role-category-popup.component';
import swal from "sweetalert2";

@Component({
  selector: 'app-user-role-categor-search-table',
  templateUrl: './user-role-categor-search-table.component.html',
  styleUrls: ['./user-role-categor-search-table.component.scss']
})
export class UserRoleCategorSearchTableComponent implements OnInit {
  @Input() items: UserRoleCategoryModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;

  userRoleCategories: UserRoleCategoryModel[];
  status = Status;

  constructor(
    private router: Router,
    private userRoleCategoryService: UserroleCategoryService,
    private roleCategoryComponent: UserRolesCategoryComponent,
    public modalService: NgbModal,) { }

  ngOnInit() {
    this.loadAllUserRoleCategory();
    this.getAll();
    this.userRoleCategoryService.resultSet.subscribe((result) => {
      this.userRoleCategories = result;
    });
  }

  loadAllUserRoleCategory() {
    this.userRoleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) =>{
        this.userRoleCategories = data;
      }
    );
  }

  getAll() {
    this.userRoleCategoryService.getAllUserRoleCategories()
      .subscribe((result) => {
        this.userRoleCategoryService.resultSet.emit(result);
        // this.userRoleCategories = result;
      });
  }

  onClickUpdate(Item){
    const modalRef = this.modalService.open(UserRoleCategoryPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update User Role Category";
    modalRef.componentInstance.userRoleCategoryCode = Item.userRoleCategoryCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.roleCategoryComponent.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onClickView(Item){
    const modalRef = this.modalService.open(UserRoleCategoryPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View User Role Category";
    modalRef.componentInstance.name = "Update User Role Category";
    modalRef.componentInstance.userRoleCategoryCode = Item.userRoleCategoryCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

  onDelete(Item){
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.userRoleCategoryService.deleteUserRoleCategory(Item.userRoleCategoryCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadAllUserRoleCategory();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
            }
          );
        }
      }, reason => {
      }
    );
  }


}
